import React from "react";
import { Card } from "components/ui/card";
import { Box } from "components/ui/box";
import { Typography } from "components/ui/Typography";
import { colors } from "src/constants";
import { BaseTemplate } from "templates/src/types";

export interface TemplateCardProps {
  template: BaseTemplate;
  sx?: React.CSSProperties;
  getNavigateProps: (slug: string) =>
    | {
        component: React.ElementType;
        to: string;
      }
    | {
        onClick: (template: BaseTemplate) => void;
      };
}

export const ViewAll = ({ sx = {}, getNavigateProps }) => {
  return (
    <Card
      {...getNavigateProps()}
      sx={{
        textDecoration: "none",
        borderRadius: "16px",
        cursor: "pointer",
        letterSpacing: "0.5px",
        position: "relative",
        boxShadow: "none",
        background: colors.white1,
        border: `1px solid ${colors.gray2}`,
        "&:hover": {
          button: {
            opacity: 1,
            zIndex: 1,
          },
        },
        margin: 0,
        minWidth: "280px",
        minHeight: "200px",
        padding: "24px 24px 0px 24px",

        flexBasis: {
          xs: "100%",
          sm: `100%`,
          md: `45%`,
          lg: "45%",
          xl: "24%",
        },
        ...sx,
      }}
    >
      <Box
        sx={{
          padding: "0",
          display: "flex",
          flexDirection: "column",
          height: "100%",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            columnGap: "12px",
          }}
        >
          <Typography
            marginTop={12}
            variant="h6"
            marginBottom={12}
            sx={{ fontWeight: 700, color: colors.black1 }}
          >
            View All
          </Typography>
        </Box>
      </Box>
    </Card>
  );
};

export const TemplateCard = ({
  getNavigateProps,
  name,
  description,
  slug,
  sx = {},
}: {
  sx?: React.CSSProperties;
  getNavigateProps: (slug: string) =>
    | {
        component: React.ElementType;
        to: string;
      }
    | {
        onClick: (template: BaseTemplate) => void;
      };
}) => {
  return (
    <Card
      {...getNavigateProps(slug)}
      sx={{
        textDecoration: "none",
        borderRadius: "16px",
        cursor: "pointer",
        letterSpacing: "0.5px",
        position: "relative",
        boxShadow: "none",
        background: colors.white1,
        border: `1px solid ${colors.gray2}`,
        "&:hover": {
          button: {
            opacity: 1,
            zIndex: 1,
          },
        },
        margin: 0,
        minWidth: "280px",
        minHeight: "200px",
        padding: "24px 24px 0px 24px",

        flexBasis: {
          xs: "100%",
          sm: `100%`,
          md: `45%`,
          lg: "45%",
          xl: "24%",
        },
        ...sx,
      }}
    >
      <Box
        sx={{
          padding: "0",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          height: "100%",
          alignItems: "flex-start",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            columnGap: "12px",
          }}
        >
          <Typography
            marginTop={12}
            variant="h6"
            marginBottom={12}
            sx={{ fontWeight: 700, color: colors.black1 }}
          >
            {name}
          </Typography>
        </Box>
        <Box
          sx={{
            lineHeight: 1.2,
          }}
        >
          <Typography
            variant="body2"
            sx={{
              fontSize: "13px",
            }}
          >
            {description}
          </Typography>
        </Box>
      </Box>
    </Card>
  );
};
